import React from 'react'
import { Asset } from '../../../../plugins/gatsby-plugin-atollon'
import { graphql } from 'gatsby'
import { BigLogo } from '../../icons'

const LandingBanner = ({image, video}) => {
  return (
    <section className={`landing-banner`}>
      <div className="landing-banner__asset">
        {video && <video className="landing-banner__video" poster={image?.url} src={video} autoPlay loop muted playsInline />}
        {image && !video && <Asset className="landing-banner__bg" asset={image} />}
      </div>
      <div className="landing-banner__inner">
        <div className="landing-banner__wrapper">
          <BigLogo color='#ffffff' />
        </div>
      </div>
    </section>
  )
}

export default LandingBanner

export const query = graphql`
  fragment LandingBannerProps on DatoCmsLandingBanner {
    ... on DatoCmsLandingBanner {
      id
      video
      image {
        ...InternalAssetProps
      }
    }
  }
`;